import { getIfRestaurantIsOpen, getRestaurantClosingHour, getMergedHoursWithHolidayHours, getMergedTimeRangeHoursWithTimeRangeHolidayHours, getIfRestaurantIsOpenNewFormat,
  getRestaurantClosingHourNewFormat } from '@/utils/restaurant/hours'
import { getLocationListItemId, getPrivateDiningId } from '@/utils/restaurant/locations'

export { getIfRestaurantIsOpen, getRestaurantClosingHour, getMergedHoursWithHolidayHours, getLocationListItemId, getPrivateDiningId, getMergedTimeRangeHoursWithTimeRangeHolidayHours, getIfRestaurantIsOpenNewFormat,
  getRestaurantClosingHourNewFormat }
